module.exports = __webpack_public_path__ + "img/gem-visa-card.615b615d.jpg";